import { trigger, state, style, transition, animate } from '@angular/animations';

export const expandElement = trigger('expandElement', [
  state('collapsed', style({ height: '0px', minHeight: '0', overflow: 'hidden' })),
  state('expanded', style({ height: '*' })),
  transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
]);

export const ghost = trigger('ghost', [
  state('faded', style({ opacity: '0.5' })),
  state('solid', style({ opacity: '1' })),
  transition('faded <=> solid', animate('500ms')),
]);
